export default "__VITE_ASSET__Fw1GjKuI__"